import { PageRouter } from "../common/pages";
import { useAccessToken } from "./access.token";

export function CPAgeRouter(props) {

    const accessToken = useAccessToken();

    return <PageRouter query={{ accessToken: accessToken.value }} {...props} />

}